import "./Fretboard.scss";

import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import times from "lodash/times";

import AudioKey from "../../lib/AudioKey";
import FretboardFretHead from "./FretboardFretHead";
import FretboardLocation from "./FretboardLocation";
import { defaultFretAmount } from "../../constants";

import {
	fretNumber,
	getSideDots,
	isDotted,
	stringNumber
} from "./lib";

class FretboardFret extends PureComponent {
	static propTypes = {
		dots: PropTypes.array,
		frets: PropTypes.number,
		highlight: PropTypes.number,
		index: PropTypes.number,
		instrument: PropTypes.string,
		locations: PropTypes.array,
		orientation: PropTypes.string,
		relativeKey: PropTypes.instanceOf(AudioKey),
		selectedKey: PropTypes.instanceOf(AudioKey),
		strings: PropTypes.array.isRequired,
		stringLayout: PropTypes.string
	};

	render() {
		let {
			dots,
			frets = defaultFretAmount,
			highlight,
			index,
			instrument,
			locations,
			orientation = "ltr",
			relativeKey,
			selectedKey,
			strings,
			stringLayout = "rh"
		} = this.props;

		let fn = fretNumber(index, frets, orientation);

		return (
			<tr key={`fret-${fn}`}>
				<FretboardFretHead
					fret={fn}
					orientation={orientation}
					key={`0-${fn}`} />
				{ times(strings.length, (m) => {
					let n = stringNumber(m, strings, orientation, stringLayout);
					let loc = locations[n][fn];
					let dotted = isDotted(1 + n, fn, dots);
					let sideDots = getSideDots(1 + n, fn, dots, strings);

					return (
						<FretboardLocation
							{...loc}
							dotted={dotted}
							fret={fn}
							highlight={highlight}
							instrument={instrument}
							relativeKey={relativeKey}
							selectedKey={selectedKey}
							sideDots={sideDots}
							string={n}
							key={`${1 + n}-${fn}`} />
					);
				}) }
			</tr>
		);
	}
}

export default FretboardFret;
